import { Component, inject } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { BackendApi } from '../../services/backend-api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AutoSizeStrategy, ColDef, GridReadyEvent } from 'ag-grid-community';
import { Service } from '../../models/service';
import { AG_GRID_LOCALE_FR } from '@ag-grid-community/locale';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-list-services',
  imports: [AgGridAngular, MatIconModule],
  templateUrl: './list-services.html',
  styleUrl: './list-services.css',
})
export class ListServices {
  constructor(
    private readonly backendApi: BackendApi
  ) { }

  private _snackBar = inject(MatSnackBar);

  public autoSizeStrategy: AutoSizeStrategy = {
    type: 'fitGridWidth',
    defaultMinWidth: 100,
  };

  public columns: ColDef<Service>[] = [
    { field: "name", headerName: "Nom", filter: true, floatingFilter: true }
  ];

  public localeText = AG_GRID_LOCALE_FR;
  
  onGridReady(event: GridReadyEvent) {
    this.backendApi.getServices().subscribe({
      next: (services) => {
        event.api.setGridOption('rowData', services);
        event.api.setGridOption('loading', false);
      },
      error: () => {
        // Error encountered
        event.api.setGridOption('loading', false);
        this._snackBar.open("Erreur rencontrée lors de la recuperation des services.");
      }
    })
  }
}
